import { memo } from "react";
import classnames from "classnames";
import { DropdownIndicatorProps } from "react-select";

import { ReactComponent as DownChevron } from "./icons/arrow.svg";


export const DropdownIndicator = memo<DropdownIndicatorProps<any>>((props) => {
  const { children, className, getStyles, innerProps } = props;

  return (
    <div
      {...innerProps}
      style={getStyles("dropdownIndicator", props) as any}
      className={classnames(
        {
          indicator: true,
          "dropdown-indicator": true,
        },
        className,
      )}
    >
      {children || <DownChevron width={12} height={6} />}
    </div>
  );
});
